export default "__VITE_ASSET__mNK34DjM__"